<template>
  <div id="app">
    <button :style="{ top: `${conrolButtonPosY}px` }" class="leftButton" v-on:click="fastBack">
      <span>PREV</span>
    </button>
    <button :style="{ top: `${conrolButtonPosY}px` }" class="rightButton" v-on:click="fastForward">
      <span>NEXT</span>
    </button>

    <div class="gallerySlide">
      <ul
        :style="{ width: `${slideContainerWidth}px`, height: `${slideItemHeight}px`, transform: `translate(${offsetX1}px, 0)` }"
      >
        <li
          v-for="item in items1"
          :key="item"
          :style="{ width: `${slideItemWidth}px`, height: `${slideItemHeight}px` }"
        >
          <img :src="`gallery_images_thumb/${item}`" v-on:click="showModal(item)" />
        </li>
      </ul>
    </div>

    <div class="gallerySlide">
      <ul
        :style="{ width: `${slideContainerWidth}px`, height: `${slideItemHeight}px`, transform: `translate(${offsetX2}px, 0)` }"
      >
        <li
          v-for="item in items2"
          :key="item"
          :style="{ width: `${slideItemWidth}px`, height: `${slideItemHeight}px` }"
        >
          <img :src="`gallery_images_thumb/${item}`" v-on:click="showModal(item)" />
        </li>
      </ul>
    </div>

    <div class="gallerySlide">
      <ul
        :style="{ width: `${slideContainerWidth}px`, height: `${slideItemHeight}px`, transform: `translate(${offsetX3}px, 0)` }"
      >
        <li
          v-for="item in items3"
          :key="item"
          :style="{ width: `${slideItemWidth}px`, height: `${slideItemHeight}px` }"
        >
          <img :src="`gallery_images_thumb/${item}`" v-on:click="showModal(item)" />
        </li>
      </ul>
    </div>

    <modal name="galleryModal" :clickToClose="false" width="100%" height="100%">
      <button class="galleryModal__leftButton" v-on:click="prevModalImage">
        <span>PREV</span>
      </button>
      <button class="galleryModal__rightButton" v-on:click="nextModalImage">
        <span>NEXT</span>
      </button>
      <img :src="`gallery_images/${currentItem}`" alt />
      <button class="galleryModal__closeButton" v-on:click="hideModal">閉じる</button>
    </modal>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  data() {
    return {
      viewMode: "desktop", // 'mobile'
      isShownModal: false,
      windowWidth: 0,
      slideContainerWidth: 0,
      slideItemWidth: 340,
      slideItemHeight: 230,
      conrolButtonPosY: 0,
      isHidden: false,
      isMouseOver: false,
      offsetX1: 0,
      offsetX2: 0,
      offsetX3: 0,
      currentItem: null,
      speed: 1,
      prevTimestamp: 0,
      fps: 60,
      items1All: [
        "81910100_778108666017894_8303240225002356736_o.jpg",
        "84136383_778107989351295_3648375689167503360_o.jpg",
        "84217906_778105676018193_4722598291806617600_o.jpg",
        "84218774_778102399351854_2774325075355107328_o.jpg",
        "84225827_778106552684772_4200750264874958848_o.jpg",
        "84243564_778107742684653_3925697054545805312_o.jpg",
        "84244086_778109279351166_304748146062262272_o.jpg",
        "84248159_778108832684544_5213074636362743808_o.jpg",
        "84257924_778104066018354_6203767701416968192_o.jpg",
        "84257924_778106512684776_3454260673675001856_o.jpg",
        "84258501_778106896018071_2930379250311626752_o.jpg",
        "84260957_778104329351661_8449253470795464704_o.jpg",
        "84261003_778102626018498_5567007171645800448_o.jpg",
        "84312809_778105642684863_4707058163826819072_o.jpg",
        "84324033_778104212685006_5126020064499204096_o.jpg",
        "84325546_778106409351453_8719014237738893312_o.jpg",
        "84337688_778105656018195_1159954311690584064_o.jpg",
        "84339755_778105236018237_760909827932160000_o.jpg",
        "84349265_778102672685160_4756161172007288832_o.jpg",
        "84350923_778102619351832_4481363460692639744_o.jpg",
        "84467594_778108486017912_5990526934562373632_o.jpg",
        "84468248_778107619351332_162901980618948608_o.jpg",
        "84470726_778108986017862_4085086121283813376_o.jpg",
        "84470729_778106962684731_983683145851207680_o.jpg",
        "84497588_778103922685035_4800869621190098944_o.jpg",
        "84497940_778105849351509_374359249418977280_o.jpg",
        "84497941_778107529351341_3056501068037881856_o.jpg",
        "84504874_778105076018253_3343703503896838144_o.jpg",
        "84520091_778107029351391_7270648053168603136_o.jpg",
        "84530893_778106219351472_2096499109136433152_o.jpg",
        "84532087_778102566018504_461173577991847936_o.jpg",
        "84535500_778102126018548_1874078588421013504_o.jpg",
        "84565987_778108082684619_3969399064042143744_o.jpg",
        "84569226_778106106018150_213833141628960768_o.jpg",
        "84569509_778109556017805_6196540113271390208_o.jpg",
        "84580836_778106016018159_7776305200150609920_o.jpg",
        "84584654_778103912685036_662201893103075328_o.jpg",
        "84596205_778105396018221_5073370920865759232_o.jpg",
        "84597661_778103312685096_3357427474890752_o.jpg",
        "84599723_778108019351292_2140545300132003840_o.jpg",
        "84601129_778104646018296_2694138937881919488_o.jpg",
        "84601129_778108392684588_44575232182190080_o.jpg",
        "84615103_778106846018076_7435303286682419200_o.jpg",
        "84617160_778104812684946_1303407722615537664_o.jpg",
        "84619038_778106976018063_321623970216411136_o.jpg",
        "84631632_778104659351628_1607099448456904704_o.jpg",
        "84636794_778105449351549_1067225117366419456_o.jpg",
        "84649851_778108129351281_1259020240633724928_o.jpg",
        "84655942_778104969351597_8483086869511274496_o.jpg",
        "84657069_778103186018442_6844876073826516992_o.jpg",
        "84663102_778104699351624_1252823616437878784_o.jpg",
        "84665340_778107949351299_4313569559568187392_o.jpg",
        "84675537_778107722684655_2936023412864188416_o.jpg",
        "84683200_778101752685252_8640112578955051008_o.jpg",
        "84685103_778107369351357_4677565448038907904_o.jpg",
        "84685103_778107752684652_595152733443457024_o.jpg",
        "84693490_778108856017875_7662230447862054912_o.jpg",
        "84697158_778102772685150_7949667882856611840_o.jpg"
      ],
      items2All: [
        "85134882_778103516018409_1363171166042193920_o.jpg",
        "85241341_778107252684702_3914923558580518912_o.jpg",
        "85252414_778105409351553_3682252518592610304_o.jpg",
        "86174345_778108609351233_7347448832994574336_o.jpg",
        "86174945_778103022685125_3539499887416573952_o.jpg",
        "86176207_778103652685062_1541177159366737920_o.jpg",
        "86176207_778109099351184_5315520206351630336_o.jpg",
        "86179584_778108696017891_9147853949011755008_o.jpg",
        "86180051_778107306018030_8139926889595666432_o.jpg",
        "86181594_778103632685064_8562964950455156736_o.jpg",
        "86183742_778104072685020_9053705298061033472_o.jpg",
        "86185359_778103742685053_3494188858617102336_o.jpg",
        "86185719_778108799351214_4442676169111764992_o.jpg",
        "86186121_778105069351587_4172369760933117952_o.jpg",
        "86186289_778105529351541_1671195629121961984_o.jpg",
        "86189856_778108956017865_4308634616375279616_o.jpg",
        "86190755_778101899351904_1699981049695567872_o.jpg",
        "86192601_778103606018400_6970950956150161408_o.jpg",
        "86192603_778106722684755_8818965002959454208_o.jpg",
        "86192879_778108362684591_8747076660697759744_o.jpg",
        "86193261_778105822684845_9110269407463997440_o.jpg",
        "86193362_778108319351262_6284244157204529152_o.jpg",
        "86194292_778101599351934_683685749014396928_o.jpg",
        "86194434_778106636018097_5682013747153993728_o.jpg",
        "86197164_778104372684990_2993555509111422976_o.jpg",
        "86197772_778108279351266_5183740512242237440_o.jpg",
        "86204195_778103436018417_139058242041937920_o.jpg",
        "86211141_778104202685007_7635374506986438656_o.jpg",
        "86216623_778102919351802_2188201393959993344_o.jpg",
        "86220865_778108162684611_1833238611986743296_o.jpg",
        "86223930_778106266018134_1007225721321422848_o.jpg",
        "86228053_778107869351307_6206790276061593600_o.jpg",
        "86232600_778103146018446_577957552701046784_o.jpg",
        "86236495_778106292684798_7227949055974834176_o.jpg",
        "86247575_778109256017835_789136748138463232_o.jpg",
        "86247581_778107499351344_412750295630610432_o.jpg",
        "86253262_778102289351865_5424697218453995520_o.jpg",
        "86256129_778106349351459_3514290924765052928_o.jpg",
        "86261196_778101606018600_923461957695045632_o.jpg",
        "86261690_778104452684982_2368811039409045504_o.jpg",
        "86262617_778108996017861_2797358246229180416_o.jpg",
        "86263340_778106442684783_3356153896828403712_o.jpg",
        "86263981_778109406017820_8166141682048303104_o.jpg",
        "86266070_778105559351538_5859298735728623616_o.jpg",
        "86266618_778102272685200_6477520223850201088_o.jpg",
        "86267049_778109389351155_2443635249515593728_o.jpg",
        "86268086_778101612685266_6310101470939185152_o.jpg",
        "86269321_778104929351601_771853151199297536_o.jpg",
        "86269950_778104316018329_5323886862773780480_o.jpg",
        "86275928_778101742685253_1496097762448506880_o.jpg",
        "86277085_778104932684934_6345162607531393024_o.jpg",
        "86277929_778105786018182_6216659466662707200_o.jpg",
        "86278323_778106136018147_8820455034488619008_o.jpg",
        "86280081_778106379351456_8061467406284881920_o.jpg",
        "86280331_778106162684811_2893175212801523712_o.jpg",
        "86281421_778102866018474_5670424782928084992_o.jpg",
        "86281671_778103466018414_5264056198813974528_o.jpg",
        "86282311_778102012685226_867444541794287616_o.jpg"
      ],
      items3All: [
        "86282798_778105269351567_129250052861329408_o.jpg",
        "86285131_778109226017838_5441652409308807168_o.jpg",
        "86285440_778107432684684_3083553971818725376_o.jpg",
        "86287102_778109156017845_1351860206459420672_o.jpg",
        "86294458_778109362684491_1083641045012447232_o.jpg",
        "86294942_778103779351716_4040474708297121792_o.jpg",
        "86295606_778104772684950_5705720459094392832_o.jpg",
        "86300939_778104792684948_5348480811878318080_o.jpg",
        "86308760_778102512685176_6465916996037902336_o.jpg",
        "86312833_778102419351852_7745780940592381952_o.jpg",
        "86322295_778107132684714_3159926547700252672_o.jpg",
        "86346863_778104052685022_5893271145355935744_o.jpg",
        "86348745_778104222685005_7971789932253413376_o.jpg",
        "86349390_778103049351789_7470172949337604096_o.jpg",
        "86349390_778103076018453_8836204718217756672_o.jpg",
        "86351837_778102259351868_2907738304440958976_o.jpg",
        "86352549_778104472684980_3605804231027589120_o.jpg",
        "86354461_778103316018429_4287729880969248768_o.jpg",
        "86359902_778107639351330_3640809837987627008_o.jpg",
        "86368970_778102139351880_3261682350236368896_o.jpg",
        "86369756_778101892685238_7964316341266022400_o.jpg",
        "86375057_778108416017919_5426778589670408192_o.jpg",
        "86376673_778105989351495_8498720421619695616_o.jpg",
        "86386397_778109132684514_1513544078518648832_o.jpg",
        "86388616_778108536017907_759326440993849344_o.jpg",
        "86396621_778102432685184_6654519390941216768_o.jpg",
        "86408135_778103352685092_4780398973833707520_o.jpg",
        "86418760_778108222684605_8769505065816817664_o.jpg",
        "86419325_778102752685152_8803074311159021568_o.jpg",
        "86426424_778107082684719_4809077909283143680_o.jpg",
        "86430882_778102149351879_4505469806455029760_o.jpg",
        "86430883_778107902684637_5091165000437858304_o.jpg",
        "86478734_778103756018385_6180217691358363648_o.jpg",
        "86501222_778105552684872_2244812842492493824_o.jpg",
        "86502251_778106496018111_5583265607136051200_o.jpg",
        "86601690_778107339351360_664675579517206528_o.jpg",
        "86615320_778105099351584_1965150191656894464_o.jpg",
        "86615328_778107142684713_7730039344286662656_o.jpg",
        "86616178_778105249351569_4828016906877272064_o.jpg",
        "86616209_778101772685250_270157845259878400_o.jpg",
        "86627750_778107246018036_7276818405049499648_o.jpg",
        "86631702_778107589351335_634646289170038784_o.jpg",
        "86633267_778102792685148_6852703827817136128_o.jpg",
        "86633708_778104512684976_5427310641629102080_o.jpg",
        "86638863_778109529351141_8309318312395800576_o.jpg",
        "86648297_778101929351901_8847650861896171520_o.jpg",
        "86695658_778108576017903_2244439854647607296_o.jpg",
        "86697040_778102002685227_3855766487226646528_o.jpg",
        "86699028_778102519351842_3042572884233945088_o.jpg",
        "86705097_778106652684762_4352143257854017536_o.jpg",
        "86705933_778102856018475_2204918682281312256_o.jpg",
        "86719620_778109496017811_2842018888131018752_o.jpg",
        "86727768_778102029351891_1588391786391273472_o.jpg",
        "86728422_778103229351771_5456681191367245824_o.jpg",
        "86728653_778105942684833_8033064418189246464_o.jpg",
        "86776580_778103882685039_7557002606648754176_o.jpg",
        "86796349_778106856018075_8573193672768618496_o.jpg",
        "86810590_778107856017975_4839858393705349120_o.jpg"
      ],
      items1: [
        "81910100_778108666017894_8303240225002356736_o.jpg",
        "84136383_778107989351295_3648375689167503360_o.jpg",
        "84217906_778105676018193_4722598291806617600_o.jpg",
        "84218774_778102399351854_2774325075355107328_o.jpg",
        "84225827_778106552684772_4200750264874958848_o.jpg",
        "84243564_778107742684653_3925697054545805312_o.jpg"
      ],
      items2: [
        "85134882_778103516018409_1363171166042193920_o.jpg",
        "85241341_778107252684702_3914923558580518912_o.jpg",
        "85252414_778105409351553_3682252518592610304_o.jpg",
        "86174345_778108609351233_7347448832994574336_o.jpg",
        "86174945_778103022685125_3539499887416573952_o.jpg",
        "86176207_778103652685062_1541177159366737920_o.jpg"
      ],
      items3: [
        "86282798_778105269351567_129250052861329408_o.jpg",
        "86285131_778109226017838_5441652409308807168_o.jpg",
        "86285440_778107432684684_3083553971818725376_o.jpg",
        "86287102_778109156017845_1351860206459420672_o.jpg",
        "86294458_778109362684491_1083641045012447232_o.jpg",
        "86294942_778103779351716_4040474708297121792_o.jpg"
      ]
    };
  },
  mounted() {
    this.testWebP().then(isWebPSupport => {
      const extension = isWebPSupport ? "webp" : "jpg";

      this.items1All = this.items1All.map(item => {
        return item.replace(/jpg$/, extension);
      });
      this.items2All = this.items2All.map(item => {
        return item.replace(/jpg$/, extension);
      });
      this.items3All = this.items3All.map(item => {
        return item.replace(/jpg$/, extension);
      });
      this.items1 = this.items1.map(item => {
        return item.replace(/jpg$/, extension);
      });
      this.items2 = this.items2.map(item => {
        return item.replace(/jpg$/, extension);
      });
      this.items3 = this.items3.map(item => {
        return item.replace(/jpg$/, extension);
      });

      window.addEventListener("resize", this.handleResize, false);
      this.handleResize();
      document.addEventListener(
        "visibilitychange",
        this.handleVisibilityChange,
        false
      );
      this.$el.addEventListener("mouseover", this.handleMouseover, false);
      this.$el.addEventListener("mouseleave", this.handleMouseleave, false);
      this.render();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
    this.$el.removeEventListener("mouseover", this.handleMouseover);
    this.$el.removeEventListener("mouseleave", this.handleMouseleave);
  },
  methods: {
    testWebP() {
      return new Promise(res => {
        const webP = new Image();
        webP.src =
          "data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA";
        webP.onload = webP.onerror = () => {
          res(webP.height === 2);
        };
      });
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
      this.viewMode = this.windowWidth <= 768 ? "mobile" : "desktop";
      const scale = this.viewMode === "mobile" ? 0.5 : 0.2;
      this.slideItemWidth = this.windowWidth * scale;
      this.slideItemHeight = this.slideItemWidth * (230 / 340);
      this.slideContainerWidth = this.items1.length * this.slideItemWidth;
      // this.offsetX1 = 0;
      this.offsetX2 = -1 * this.slideItemWidth;
      // this.offsetX3 = 0;
      this.conrolButtonPosY = this.slideItemHeight * 3 * 0.5;
    },
    handleVisibilityChange() {
      this.isHidden = document.hidden;
    },
    handleMouseover() {
      this.isMouseOver = true;
    },
    handleMouseleave() {
      this.isMouseOver = false;
    },
    render(timestamp) {
      const elapsed = (timestamp - this.prevTimestamp) / 1000;
      if (elapsed <= 1 / this.fps) {
        window.requestAnimationFrame(this.render);
        return;
      }
      this.update();
      this.prevTimestamp = timestamp;
      window.requestAnimationFrame(this.render);
    },
    update() {
      if (this.isHidden || this.isShownModal) {
        return;
      }

      this.offsetX1 += -1 * this.speed;
      this.offsetX2 += this.speed;
      this.offsetX3 += -1 * this.speed;

      if (this.offsetX1 < -1 * this.slideItemWidth) {
        this.offsetX1 = 0;
        const _items = this.items1;
        const _last = _items[_items.length - 1];
        let index;
        if (this.items1All.indexOf(_last) !== -1) {
          index = this.items1All.indexOf(_last) + 1;
          if (this.items1All.length - 1 < index) {
            index = 0;
          }
          _items.shift();
          _items.push(this.items1All[index]);
          this.$set(this, "items1", _items);
        }
      }

      if (0 < this.offsetX2) {
        this.offsetX2 = -1 * this.slideItemWidth;
        const _items = this.items2;
        const _first = _items[0];
        let index;
        if (this.items2All.indexOf(_first) !== -1) {
          index = this.items2All.indexOf(_first) - 1;
          if (index < 0) {
            index = this.items2All.length - 1;
          }
          _items.pop();
          _items.unshift(this.items2All[index]);
          this.$set(this, "items2", _items);
        }
      }

      if (this.offsetX3 < -1 * this.slideItemWidth) {
        this.offsetX3 = 0;
        const _items = this.items3;
        const _last = _items[_items.length - 1];
        let index;
        if (this.items3All.indexOf(_last) !== -1) {
          index = this.items3All.indexOf(_last) + 1;
          if (this.items3All.length - 1 < index) {
            index = 0;
          }
          _items.shift();
          _items.push(this.items3All[index]);
          this.$set(this, "items3", _items);
        }
      }
    },
    showModal(item) {
      this.isShownModal = true;
      this.currentItem = item;
      this.$modal.show("galleryModal");
      this.render();
    },
    hideModal() {
      this.$modal.hide("galleryModal");
      this.currentItem = null;
      this.isShownModal = false;
      this.render();
    },
    fastBack() {
      const tmpSpeed = 0 + this.speed;
      setTimeout(() => {
        this.speed = tmpSpeed;
      }, 100);
      this.speed = -1 * this.slideItemWidth * 3;
    },
    fastForward() {
      const tmpSpeed = 0 + this.speed;
      setTimeout(() => {
        this.speed = tmpSpeed;
      }, 100);
      this.speed = this.slideItemWidth * 3;
    },
    prevModalImage() {
      const item = this.currentItem;
      const itemsAll = [
        ...this.items1All,
        ...this.items2All,
        ...this.items3All
      ];
      const index = itemsAll.indexOf(item);
      if (index !== -1) {
        if (index === 0) {
          this.currentItem = itemsAll[this.items1.length - 1];
        } else {
          this.currentItem = itemsAll[index - 1];
        }
      }
    },
    nextModalImage() {
      const item = this.currentItem;
      const itemsAll = [
        ...this.items1All,
        ...this.items2All,
        ...this.items3All
      ];
      const index = itemsAll.indexOf(item);
      if (index !== -1) {
        if (index === itemsAll.length - 1) {
          this.currentItem = itemsAll[0];
        } else {
          this.currentItem = itemsAll[index + 1];
        }
      }
    }
  }
};
</script>

<style>
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}
#app {
  position: relative;
  width: 100%;
  height: 100%;
  background: #096fca;
}
.gallerySlide {
  overflow: hidden;
}
.gallerySlide ul {
  will-change: transform;
  display: flex;
  align-items: center;
  height: 230px;
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.gallerySlide li {
  display: block;
  width: 340px;
  height: 230px;
  margin: 0;
  padding: 0;
}
.gallerySlide img {
  display: block;
  width: 100%;
  max-width: 100%;
  cursor: pointer;
  background: #000;
}
.leftButton {
  position: absolute;
  top: 50%;
  left: 50px;
  transform: translate(0, -50%);
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 94px;
  height: 94px;
  border-radius: 47px;
  background: rgba(9, 111, 202, 0.57);
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0;
  appearance: none;
  transition: all 0.2s ease-in;
}
.leftButton:hover {
  background: rgba(9, 111, 202, 1);
}
.leftButton:active {
  background: rgba(9, 111, 202, 0.57);
}
.leftButton span {
  display: block;
  width: 14px;
  height: 14px;
  margin-left: 6px;
  border-bottom: 2px solid #fff;
  border-left: 2px solid #fff;
  transform: rotate(45deg);
  text-indent: 101%;
  white-space: nowrap;
  overflow: hidden;
}
.rightButton {
  position: absolute;
  top: 50%;
  right: 50px;
  transform: translate(0, -50%);
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 94px;
  height: 94px;
  border-radius: 47px;
  background: rgba(9, 111, 202, 0.57);
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0;
  appearance: none;
  transition: all 0.2s ease-in;
}
.rightButton:hover {
  background: rgba(9, 111, 202, 1);
}
.rightButton:active {
  background: rgba(9, 111, 202, 0.57);
}
.rightButton span {
  display: block;
  width: 14px;
  height: 14px;
  margin-right: 6px;
  border-bottom: 2px solid #fff;
  border-left: 2px solid #fff;
  transform: rotate(-135deg);
  text-indent: 101%;
  white-space: nowrap;
  overflow: hidden;
}

.v--modal {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 1100px;
  margin: 0 auto;
}
.v--modal img {
  display: block;
  max-width: 885px;
  width: 100%;
  margin: 0 auto;
}
.v--modal .galleryModal__rightButton {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(0, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 64px;
  height: 64px;
  background: transparent;
  cursor: pointer;
  outline: none;
  border: none;
  padding: 0;
  appearance: none;
  opacity: 1;
  transition: all 0.2s ease-in;
}
.v--modal .galleryModal__rightButton:hover {
  opacity: 0.7;
}
.v--modal .galleryModal__rightButton:active {
  opacity: 1;
}
.v--modal .galleryModal__rightButton span {
  display: block;
  width: 64px;
  height: 64px;
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2234%22%20height%3D%2263%22%20viewBox%3D%220%200%2034%2063%22%3E%3Cpath%20d%3D%22M35.967%2C33.3%2C10.178%2C6.5a2.513%2C2.513%2C0%2C0%2C1%2C0-3.534%2C2.458%2C2.458%2C0%2C0%2C1%2C3.5%2C0L41.953%2C31.527a2.513%2C2.513%2C0%2C0%2C1%2C0%2C3.534L13.677%2C63.62a2.454%2C2.454%2C0%2C0%2C1-3.5%2C0%2C2.513%2C2.513%2C0%2C0%2C1%2C0-3.534L35.967%2C33.3Z%22%20transform%3D%22translate(-9.452%20-2.238)%22%20fill%3D%22%23fff%22%2F%3E%3C%2Fsvg%3E");
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: contain;
  text-indent: 101%;
  white-space: nowrap;
  overflow: hidden;
}
.v--modal .galleryModal__leftButton {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 64px;
  height: 64px;
  background: transparent;
  cursor: pointer;
  outline: none;
  border: none;
  padding: 0;
  appearance: none;
  opacity: 1;
  transition: all 0.2s ease-in;
}
.v--modal .galleryModal__leftButton:hover {
  opacity: 0.7;
}
.v--modal .galleryModal__leftButton:active {
  opacity: 1;
}
.v--modal .galleryModal__leftButton span {
  display: block;
  width: 64px;
  height: 64px;
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2234%22%20height%3D%2263%22%20viewBox%3D%220%200%2034%2063%22%3E%3Cpath%20d%3D%22M16.164%2C33.3%2C41.953%2C6.5a2.513%2C2.513%2C0%2C0%2C0%2C0-3.534%2C2.458%2C2.458%2C0%2C0%2C0-3.5%2C0L10.178%2C31.527a2.513%2C2.513%2C0%2C0%2C0%2C0%2C3.534L38.454%2C63.62a2.454%2C2.454%2C0%2C0%2C0%2C3.5%2C0%2C2.513%2C2.513%2C0%2C0%2C0%2C0-3.534L16.164%2C33.3Z%22%20transform%3D%22translate(-9.452%20-2.238)%22%20fill%3D%22%23fff%22%2F%3E%3C%2Fsvg%3E");
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: contain;
  text-indent: 101%;
  white-space: nowrap;
  overflow: hidden;
}
.v--modal .galleryModal__closeButton {
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translate(-50%, 0);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 190px;
  height: 48px;
  background: transparent;
  cursor: pointer;
  outline: none;
  padding: 0;
  appearance: none;
  transition: all 0.2s ease-in;
  border: 1px solid #fff;
  border-radius: 24px;
  font-weight: bold;
  font-size: 14px;
  letter-spacing: 0.04em;
  line-height: 1;
  text-align: center;
  color: #fff;
  opacity: 1;
}
.v--modal .galleryModal__closeButton::before {
  content: "";
  display: block;
  width: 20px;
  height: 20px;
  margin-right: 7px;
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2219%22%20height%3D%2219%22%20viewBox%3D%220%200%2019%2019%22%3E%3Cpath%20d%3D%22M-2181-3471v-6h-6v-1h6v-6h1v6h6v1h-6v6Z%22%20transform%3D%22translate(-907.925%204010.002)%20rotate(45)%22%20fill%3D%22%23fff%22%2F%3E%3C%2Fsvg%3E");
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: contain;
}
.v--modal .galleryModal__closeButton:hover {
  opacity: 0.7;
}
.v--modal .galleryModal__closeButton:active {
  opacity: 1;
}
@media screen and (max-width: 768px) {
  /* スマホ表示 */
  .rightButton {
    display: none;
  }
  .leftButton {
    display: none;
  }
  .v--modal {
    padding-right: 10.133333vw !important;
    padding-left: 10.133333vw !important;
  }
  .v--modal .galleryModal__rightButton {
    right: 12px;
    width: 16px;
    height: 16px;
  }
  .v--modal .galleryModal__rightButton span {
    width: 16px;
    height: 16px;
  }
  .v--modal .galleryModal__leftButton {
    left: 12px;
    width: 16px;
    height: 16px;
  }
  .v--modal .galleryModal__leftButton span {
    width: 16px;
    height: 16px;
  }
  .v--modal .galleryModal__closeButton {
    width: 50.666666vw;
  }
}
</style>
